export default "<app-loader></app-loader>\n<app-master id=\"masterc\">\n    <router-outlet></router-outlet>\n</app-master>"